module.exports = __webpack_public_path__ + "img/NDZ_Header_Thorns.0c0443f9.svg";